import React from "react";
import "./iconLanguageHLPure.css";

const IconLanguageHLPure = (props) => {
    let {   
        label,
        status
    } = props

    return(
        <div >
            <h1 className={(status) ? "iconLanguageHLPure-label-selected" : "iconLanguageHLPure-label"}  >{label}</h1>
        </div>
    )
}

export { IconLanguageHLPure as default }